import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

import { sendApiRequest, notifyError, notifyWarning } from "../actions";

import generateError from "../utilities/generateError";
import { SCORE_CARD_RESULT_MESSAGE } from "../features/monitoring-queue-entry/constants/scoreCardsResultMessage";
import { GET_SCORE_CARDS_BY_TYPE } from "../types/getScoreCardsByTypeTypes";
import {
  getScoreCardsByTypeRejected,
  getScoreCardsByTypeFulfilled,
  getScoreCardsByTypePending,
} from "../actions/getScoreCardsByTypeActions";

const createPayload = (payload) => ({
  method: "get",
  url: "scorecard/ScoreCardsByType",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning(SCORE_CARD_RESULT_MESSAGE.NOT_FOUND)
        : getScoreCardsByTypeFulfilled(response),
  ],
  onError: [
    getScoreCardsByTypeRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getScoreCardsByTypeEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_SCORE_CARDS_BY_TYPE.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(getScoreCardsByTypePending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getScoreCardsByTypeEpic$;



// WEBPACK FOOTER //
// ./src/epics/getScoreCardsByTypeEpic.js